import { render, staticRenderFns } from "./GrabbingScheduleView.vue?vue&type=template&id=3520b578&scoped=true"
import script from "./GrabbingScheduleView.vue?vue&type=script&lang=ts"
export * from "./GrabbingScheduleView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3520b578",
  null
  
)

export default component.exports